export default __webpack_public_path__ + "static/media/orusNFT.eae4d594.png";